import { Stack } from "@mui/joy";
import PCSideTab from "./PCSideTab";
import SidebarForPatient from "./SidebarForPatient";
import useIsInappWebview from "hooks/useIsInappWebview";
import { pcTabFromPath } from "../../recoil/pcSideTabAtom";
import { useLocation } from "react-router-dom";

export default function SideBarLayoutForPatient() {
  const location = useLocation();
  // 홈 작업목록 사이드바 노출도 atom 이 아니라 URL 에서 파생(PCSideTab 하이라이트와 동일 기준).
  // → '나' 섹션(/payment-history 등)에선 홈 사이드바가 뜨지 않아 탭=콘텐츠 불일치를 막는다.
  const isHomeTab = pcTabFromPath(location.pathname) === "home";

  const isInappWebview = useIsInappWebview();

  return isInappWebview ? (
    <SidebarForPatient isHome={window.location.pathname === "/"} />
  ) : (
    <Stack direction="row" sx={{ height: "100vh", overflow: "hidden" }}>
      <PCSideTab />
      {isHomeTab ? (
        <SidebarForPatient isHome={window.location.pathname === "/"} />
      ) : (
        <></>
      )}
    </Stack>
  );
}
